"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapPixelRequestToJSON = exports.MapPixelRequestFromJSONTyped = exports.MapPixelRequestFromJSON = exports.instanceOfMapPixelRequest = void 0;
var runtime_1 = require("../runtime");
var MapRequestState_1 = require("./MapRequestState");
/**
 * Check if a given object implements the MapPixelRequest interface.
 */
function instanceOfMapPixelRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfMapPixelRequest = instanceOfMapPixelRequest;
function MapPixelRequestFromJSON(json) {
    return MapPixelRequestFromJSONTyped(json, false);
}
exports.MapPixelRequestFromJSON = MapPixelRequestFromJSON;
function MapPixelRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'adAccountId': !(0, runtime_1.exists)(json, 'ad_account_id') ? undefined : json['ad_account_id'],
        'state': !(0, runtime_1.exists)(json, 'state') ? undefined : (0, MapRequestState_1.MapRequestStateFromJSON)(json['state']),
        'requestorId': !(0, runtime_1.exists)(json, 'requestor_id') ? undefined : json['requestor_id'],
        'spaaOrgId': !(0, runtime_1.exists)(json, 'spaa_org_id') ? undefined : json['spaa_org_id'],
    };
}
exports.MapPixelRequestFromJSONTyped = MapPixelRequestFromJSONTyped;
function MapPixelRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'ad_account_id': value.adAccountId,
        'state': (0, MapRequestState_1.MapRequestStateToJSON)(value.state),
        'requestor_id': value.requestorId,
        'spaa_org_id': value.spaaOrgId,
    };
}
exports.MapPixelRequestToJSON = MapPixelRequestToJSON;
